import CardsContainer from "components/CardsContainer";
import getUrlFromLink from "utils/getUrlFromLink";
import type { ResolvedLinkProps } from "types/storyblok.d";
import type { CardsItemDesktop } from "components/CardsDesktop";
import type { CardsItemMobile } from "components/CardsMobile";
import type { ReactStoryblokComponent } from "../types";

export interface CardsBlokProps {
  cards: CardsItemMobile[] | CardsItemDesktop[];
  cardsHeightDesktop: string;
  cardsUrl?: ResolvedLinkProps;
}

const CardsAdapter = ({ blok: { cards, cardsHeightDesktop, cardsUrl } }: ReactStoryblokComponent<CardsBlokProps>) => {
  const url = getUrlFromLink(cardsUrl);

  return <CardsContainer cards={cards} cardsHeightDesktop={cardsHeightDesktop} cardsUrl={url} />;
};

export default CardsAdapter;
